<template>
    <div :class="['want-carousel', { hidden: hidden }]" v-if="show">
        <div class="want-carousel_list" ref="carouselRef" v-draggle-scroll-x.snap @scroll="getCurrentIndex">
            <div class="carousel-item" v-for="(item, index) in options" :key="index">
                <img class="carousel-item_img" :src="item.img" alt="" />

                <div class="carousel-item_title">{{ item.label }}</div>

                <div class="carousel-item_desc">{{ item.desc }}</div>

                <div class="carousel-item_button" @click="close">
                    我知道了
                </div>

                <i class="el-icon-error" @click="close"></i>
            </div>
        </div>

        <div class="want-carousel_indicator">
            <div
                :class="['indicator-item', { 'is-check': item === currentIndex + 1 }]"
                v-for="item in options.length"
                :key="item"
                @click="handleToCarousel(item)"
            ></div>
        </div>
    </div>
</template>

<script>
import { draggleScrollX } from "@/utils/directives.js";

export default {
    name: "WantCarousel",
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            options: [
                {
                    label: "点赞评论量",
                    desc: "通过推广，提升视频的点赞量、评论量、播放时长、完播率等互动表现，同时在自然流量上获得更多曝光和互动",
                    img: require("@/assets/images/training/want-1.png"),
                },
                {
                    label: "快速涨粉",
                    desc: "把你账号下优秀的视频内容，推给可能对你内容感兴趣的用户并引导关注，打到快速积累粉丝的目的",
                    img: require("@/assets/images/training/want-2.png"),
                },
                {
                    label: "主页浏览量",
                    desc: "对你视频感兴趣的用户，并进入你的个人主页，观看更多精彩内容",
                    img: require("@/assets/images/training/want-3.png"),
                },
                {
                    label: "智能优化",
                    desc: "智能优化目标将根据视频内容，由系统智能筛选，推荐给最合适的人群进行加热展示",
                    img: require("@/assets/images/training/want-4.png"),
                },
            ],
            scrollStep: [],
            hidden: false,
            currentIndex: -1,
        };
    },
    directives: {
        draggleScrollX: draggleScrollX,
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.getScrollStep();
                    this.getCurrentIndex();
                });
            }
        },
    },
    computed: {},
    mounted() {},
    methods: {
        getScrollStep() {
            const el = this.$refs.carouselRef;
            if (!el) return;

            this.scrollStep = [0];
            const childrenNodes = Array.from(el.children);
            childrenNodes.forEach((childrenNode, index) => {
                const rectWidth = childrenNode.getBoundingClientRect().width;
                const style = window.getComputedStyle(childrenNode);
                const nodeWidth = rectWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight);

                if (index !== childrenNodes.length - 1) {
                    this.scrollStep[index + 1] = nodeWidth + this.scrollStep[index];
                }
            });
        },

        getCurrentIndex() {
            const el = this.$refs.carouselRef;
            if (!el) return;

            const diffScroll = this.scrollStep.map((step) => Math.abs(step - el.scrollLeft));
            const minDiffIndex = diffScroll.indexOf(Math.min(...diffScroll));

            this.currentIndex = minDiffIndex;
        },

        handleToCarousel(item) {
            const el = this.$refs.carouselRef;
            if (!el) return;

            el.scrollTo({
                left: this.scrollStep[item - 1],
                behavior: "smooth",
            });
        },

        close() {
            this.hidden = true;
            this.$emit("close");
        },
    },
};
</script>
<style lang="scss" scoped>
.want-carousel {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    font-family: PingFang-FC;

    &_list {
        width: 100%;
        display: flex;

        .carousel-item {
            flex-shrink: 0;
            width: calc(100% - 80px);
            margin-inline: 40px;
            border-radius: 16px;
            overflow: hidden;
            background-color: #ffffff;
            position: relative;

            &_img {
                width: 100%;
                height: auto;
                object-fit: cover;
                margin: 0;
            }

            &_title {
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-weight: 600;
                font-size: 16px;
            }

            &_desc {
                height: 80px;
                box-sizing: border-box;
                text-align: center;
                font-size: 13px;
                padding: 0px 16px;
            }

            &_button {
                height: 45px;
                line-height: 45px;
                cursor: pointer;
                border-top: 1px solid #f1f1f1;
                text-align: center;
                font-size: 16px;
            }

            i.el-icon-error {
                color: #8aa6b1;
                // color: red;
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 27px;
                cursor: pointer;
            }
        }
    }

    &_indicator {
        // background-color: red;
        position: absolute;
        width: 100%;
        height: 20px;
        left: 0;
        box-sizing: border-box;
        top: calc(50% + 170px);
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        .indicator-item {
            width: 8px;
            height: 8px;
            background-color: #838383d7;
            border-radius: 50%;
            cursor: pointer;

            &.is-check {
                background-color: #ffffff;
            }
        }
    }
}
</style>
